module.exports = __webpack_public_path__ + "static/img/tallpopie.6a82b458.png";